module.exports = __webpack_public_path__ + "fonts/subset-TitilliumWeb-Regular.f247e43a.woff";